import { render } from "./SomethingWrongModal.vue?vue&type=template&id=f1084dd6&scoped=true"
import script from "./SomethingWrongModal.vue?vue&type=script&lang=js"
export * from "./SomethingWrongModal.vue?vue&type=script&lang=js"

import "./SomethingWrongModal.vue?vue&type=style&index=0&id=f1084dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1084dd6"]])

export default __exports__